import { Component, Inject } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ResultsService } from '../../../services/reports/results.service'
import { ResultsChart } from './results-chart.component';
import {MatSnackBar} from '@angular/material/snack-bar';
import { environment } from '../../../../environments/environment'

@Component({
    selector: 'results-dialog',
    templateUrl: 'results.component.html',
})
export class ResultsDialog {
    groupsId;
    selectedGroups;
    patient;
    group;
    filteredResults;
    env = environment;
    constructor(
        public dialogRef: MatDialogRef<ResultsDialog>,
        private service: ResultsService,
        public dialog: MatDialog,
        private snackBar: MatSnackBar,
        @Inject(MAT_DIALOG_DATA) public data: any) {

        this.groupsId = [... new Set(this.data.results.map(res => res.groupId))]
        this.selectedGroups = [... new Set(this.data.results.map(res => res.groupId))]
        this.patient = this.data.patient;
        this.group = this.data.group;

        this.filteredResults = data.results;
    }



    ;
    filterResults(group) {
        this.addOrRemove(group)
        this.filteredResults = this.data.results.filter(
            function (e) {
                return this.indexOf(e.groupId) > -1;
            },
            this.selectedGroups);
    }

    addOrRemove(value) {
        var index = this.selectedGroups.indexOf(value);

        if (index === -1) {
            this.selectedGroups.push(value);
        } else if (this.selectedGroups.length > 1) {
            this.selectedGroups.splice(index, 1);
        }
    }

    isSelected(group) {
        return this.selectedGroups.indexOf(group) > -1
    }

    getPreviousResults(test) {
        this.service.getPreviousResults(test, this.patient.id).subscribe(
            resp => {
                if (resp.length > 0) {
                    this.dialog.open(ResultsChart, {
                        data: {
                            patient: this.patient,
                            results: resp,
                            referenceValueMin: test.referenceValueMin,
                            referenceValueMax: test.referenceValueMax,
                            unit: test.measureUnit,
                            description: test.testDescription,
                            id: test.testId
                        }
                    })
                }
                else {
                    this.snackBar.open("No hay resultados anteriores", "x", {
                        duration: 2000,
                    });
                }
            }
        )
    }
}